import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { getConsent } from "@/context/I18nContext";

const KEY = "clipx_ad";
const SRCS = ["tiktok", "instagram", "facebook", "youtube", "snapchat", "x", "other"];
const visitorId = () => {
  let v = localStorage.getItem("clipx_vid");
  if (!v) { v = (crypto.randomUUID?.() || `${Date.now()}${Math.random()}`).replace(/[^a-z0-9]/gi, "").slice(0, 32); localStorage.setItem("clipx_vid", v); }
  return v;
};
const allowed = () => !!getConsent()?.analytics;

export const AdCapture = () => {
  const { search } = useLocation();
  const { user } = useAuth();
  const [click, setClick] = useState(null);
  const [consent, setConsent] = useState(allowed());
  useEffect(() => {
    const on = () => setConsent(allowed());
    window.addEventListener("clipx-consent", on);
    return () => window.removeEventListener("clipx-consent", on);
  }, []);
  useEffect(() => {
    const p = new URLSearchParams(search);
    const ad = p.get("ad");
    if (ad && /^\d{2}-[a-z0-9-]{2,40}$/.test(ad)) setClick({ ad, src: SRCS.includes(p.get("src")) ? p.get("src") : "other", at: Date.now() });
  }, [search]);
  useEffect(() => {
    if (!click || !consent || user === null) return;
    setClick(null);
    if (user) return;
    localStorage.setItem(KEY, JSON.stringify(click));
    api.post("/ads/visit", { ad: click.ad, src: click.src, vid: visitorId() }).catch(() => {});
  }, [click, consent, user]);
  useEffect(() => {
    if (!user) return;
    const raw = localStorage.getItem(KEY);
    if (!raw) return;
    localStorage.removeItem(KEY);
    try { api.post("/me/attribution", JSON.parse(raw)).catch(() => {}); } catch { /* ignore */ }
  }, [user]);
  return null;
};
